import React, { useEffect, useState } from "react";
import { Dropdown, Menu } from "antd";
import ProfileButton from "../Buttons/profile";
import URL from "../../Main/url";
import DefaultImage from "../../Assets/Images/defaultimage.png";
import { get_sub_branches, clear_switch_branch, switch_branch_token } from "../../Controllers/Settings/Branches";
import toast from "react-hot-toast";

const Topbar = (props) => {
  let { body } = props;

  const { role } = body || {};

  const [subBranches, setSubBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [originalBranch, setOriginalBranch] = useState(body?.branch);

  useEffect(() => {
    const savedBranch = localStorage.getItem("selectedBranch");
    if (savedBranch) {
      try {
        const branchData = JSON.parse(savedBranch);
        setSelectedBranch(branchData);
      } catch (error) {
        console.error("Error parsing saved branch:", error);
      }
    }
    setOriginalBranch(body?.branch);
  }, [body?.branch]);

  const fetchData = async () => {
    const res = await get_sub_branches();

    if (res?.status) {
      setSubBranches(res?.data?.data || []);
    } else {
      toast.error(res?.message);
    }
  };

  const handleSwitchBranch = async (branch) => {
    const res = await switch_branch_token(branch._id);

    if (res?.status) {
      localStorage.setItem("user", res.data.token);

      const branchInfo = {
        _id: branch._id,
        name: branch.name,
        image: branch.image
      };
      localStorage.setItem("selectedBranch", JSON.stringify(branchInfo));

      setSelectedBranch(branchInfo);

      toast.success("Branch switched successfully");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      toast.error(res?.message);
    }
  };

  const handleClearSwitch = async () => {
    const res = await clear_switch_branch();

    if (res?.status) {
      localStorage.setItem("user", res.data.token);

      localStorage.removeItem("selectedBranch");

      setSelectedBranch(null);

      toast.success("Switched to original branch");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      toast.error(res?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getDisplayBranch = () => {
    return selectedBranch || originalBranch;
  };

  const displayBranch = getDisplayBranch();

  const menu = (
    <Menu>
      <Menu.ItemGroup title="Switch to Branch">
        {subBranches.length ? (
          subBranches.map((branch) => (
            <Menu.Item
              key={branch._id}
              onClick={() => handleSwitchBranch(branch)}
              className={selectedBranch?._id === branch._id ? "bg-blue-50" : ""}
            >
              <div className="flex items-center justify-between">
                <span>{branch.name}</span>
                {selectedBranch?._id === branch._id && (
                  <span className="text-blue-600 text-xs">✓ Selected</span>
                )}
              </div>
            </Menu.Item>
          ))
        ) : (
          <Menu.Item disabled>No Sub Branches</Menu.Item>
        )}
      </Menu.ItemGroup>

      {selectedBranch && (
        <>
          <Menu.Divider />
          <Menu.Item
            onClick={handleClearSwitch}
            className="text-red-600 hover:text-red-700"
          >
            Clear Switch (Back to Original)
          </Menu.Item>
        </>
      )}
    </Menu>
  );

  return (
    <div className="bg-white fixed top-0 left-0 w-full z-50 h-16">
      <div className="mx-auto flex items-center h-full">
        <div className="w-64 border-b border-r flex items-center h-full">
          <ProfileButton body={body} />
        </div>

        <div className="px-4 flex-1 border-b flex items-center h-full justify-between">
          <div className="flex items-center">
            <img
              src={
                displayBranch?.image
                  ? `${URL}/uploads${displayBranch.image}`
                  : DefaultImage
              }
              className="w-[40px] h-[40px] rounded-md object-cover"
              alt="Branch"
            />
            <div className="pl-2 font-medium">
              {displayBranch?.name || "Unknown Branch"}
              {selectedBranch && (
                <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                  Switched
                </span>
              )}
            </div>
          </div>

          {role === "SUPERADMIN" && (
            <Dropdown overlay={menu} trigger={["click"]}>
              <span className="cursor-pointer font-medium text-blue-600">
                {selectedBranch ? "Change Branch" : "Switch Branch"}
              </span>
            </Dropdown>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;